import { apiRequest } from "./client";

export interface DashboardPeriodStat {
    orders_count: number;
    orders_sum: string;
}

export interface DashboardEventStat {
    tour_id: string;
    tour_name: string;
    total_tickets: number;
    sold_tickets: number;
    sold_sum: string;
    average_check: string;
}

export interface DashboardOrderCustomer {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    address: string;
    zip_code: string;
}

export interface DashboardRecentOrder {
    id: string;
    order_number: string;
    created_at: string;
    total_price: string;
    paid_amount: string;
    payment_type: string;
    is_paid: boolean;
    is_deleted: boolean;
    customer: DashboardOrderCustomer;
}

export interface DashboardResponse {
    today: DashboardPeriodStat;
    week: DashboardPeriodStat;
    month: DashboardPeriodStat;
    year: DashboardPeriodStat;
    events: DashboardEventStat[];
    recent_orders: DashboardRecentOrder[];
}

export const getDashboardRequest = async (): Promise<DashboardResponse> => {
    return apiRequest<DashboardResponse>("/dashboard", {
        method: "GET",
        auth: true,
    });
};
